import React from "react";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { NOTIFICATION_ACTIONS } from "../../constants/notificationTypes";
import { getReport } from "../../services/reportService";
import { dismissNotification } from "../../services/notificationService";
import { notificationActions } from "../../redux/reducers/notificationReducer";
import moment from "moment";
import SFNotification from "./notification";

export const PopupPanelBody = (props) => {
  const { t } = useTranslation();
  const [downloadActive, setDownloadActive] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleNotificationClick = (notif) => {
    switch (notif.customAction) {
    case NOTIFICATION_ACTIONS.DOWNLOAD:
      if (!downloadActive) {
        setDownloadActive(notif.id);
        getReport(notif.actionUrl, notif.type).finally((response) => {
          setDownloadActive(null);
          dismissNotification(notif.id).then((res) => {
            dispatch(notificationActions.dismissNotification(notif.id));
          });
        });
      }
      break;
    case NOTIFICATION_ACTIONS.NAVIGATE:
      props.onClose();
      navigate(notif.actionUrl);
      break;
    default:
      break;
    }
  };

  return props.notifications.map((notif) => {
    let formatedDate = moment(notif.createdAt, moment.ISO_8601).isSame(
      moment(),
      "day"
    )
      ? t("components.notificationDateToday")
      : moment(notif.createdAt, moment.ISO_8601).isSame(
        moment().subtract(1, "days"),
        "day"
      )
        ? t("components.notificationDateYesterday")
        : moment(notif.createdAt, moment.ISO_8601).format("D-MMM-YY | HH:mm");
    const handleClose = (id) => {
      dismissNotification(id).then((res) => {
        dispatch(notificationActions.dismissNotification(id));
      });
    };
    return (
      <SFNotification
        key={notif.id}
        message={notif.title}
        date={formatedDate}
        onClose={() => handleClose(notif.id)}
        actionProps={
          notif.actionUrl
            ? {
              label:
                  notif.customAction === NOTIFICATION_ACTIONS.NAVIGATE
                    ? t("components.notificationNavigate")
                    : downloadActive === notif.id
                      ? t("components.notificationDownloading")
                      : t("components.notificationDownload"),
              onClick: () => handleNotificationClick(notif),
            }
            : {}
        }
      />
    );
  });
};
